import { createStyles, getStylesRef } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'block',
      position: 'relative',
      backgroundColor: '#fff',
      borderRadius: 32,
      border: `1px solid ${theme.colors.neutral[1]}`,
      [theme.fn.smallerThan('sm')]: {
        borderRadius: 16,
      },
      [theme.fn.largerThan('sm')]: {
        '&:hover': {
          [`.${getStylesRef('thumbnailImg')}`]: {
            transform: 'scale(1.1)',
          },
        },
      },
    },
    info: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      padding: 16,
      [theme.fn.largerThan('sm')]: {
        padding: '24px 32px 32px',
      },
    },
    bg: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 0,
      width: '100%',
      borderRadius: 'inherit',
      overflow: 'hidden',
      border: '2px solid transparent',
    },
    thumbnail: {
      zIndex: 1,
      overflow: 'hidden',
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      img: {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
      },
    },
    img: {
      ref: getStylesRef('thumbnailImg'),
      transition: 'all 0.3s ease',
    },
  }
})
